import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useServiceStore } from "@/stores/serviceStore";
import { ITermsInfo } from "@/domain/entities/serviceInfo/termsInfo";
import { useRoute } from "vue-router";


const __default__ = {
  name: "TermsOutLink",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const serviceStore = useServiceStore();
const termsList = ref<ITermsInfo[]>();
const selectedTerms = ref<ITermsInfo>();

const getTerms = async () => {
  const serviceInfoResult = await serviceStore.getServiceInfo();
  termsList.value = serviceInfoResult.data?.termsList ?? [];
  const code = route.query.code?.toString() ?? "";
  selectedTerms.value = termsList.value?.find((terms) => terms.code === code);
};

onMounted(() => {
  getTerms();
});

const __returned__ = { route, serviceStore, termsList, selectedTerms, getTerms, NavigationBar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})